import type { ISelectItem } from '~/types/models'

export enum FieldSetFieldShowForRoutes {
  COMPANIES = 'Companies',
  OPPORTUNITIES = 'Opportunities',
  MASTER_ORDERS = 'Orders',
}

// Written out rather than derived: no suffix rule singularizes English (the
// retired singularize() turned 'boxes' into 'bo', and its proposed fix turned
// 'cases' into 'cas'). A Record, so a new route fails typecheck until it has one.
const singularByRoute: Record<FieldSetFieldShowForRoutes, string> = {
  [FieldSetFieldShowForRoutes.COMPANIES]: 'Company',
  [FieldSetFieldShowForRoutes.OPPORTUNITIES]: 'Opportunity',
  [FieldSetFieldShowForRoutes.MASTER_ORDERS]: 'Order',
}

export function getFieldSetFieldShowForRoutes(): FieldSetFieldShowForRoutes[] {
  return [
    FieldSetFieldShowForRoutes.COMPANIES,
    FieldSetFieldShowForRoutes.OPPORTUNITIES,
    FieldSetFieldShowForRoutes.MASTER_ORDERS,
  ]
}

export function getFieldSetFieldShowForRoutesDefault() {
  return getFieldSetFieldShowForRoutes()
}

export function getPreviewFieldSetFieldShowForRoutesDefault(): ISelectItem[] {
  return getFieldSetFieldShowForRoutes().map((route) => {
    return {
      id: route,
      label: `Show Fields for ${singularByRoute[route]} Views`,
    }
  })
}
